export default "__VITE_ASSET__CiyfDN8C__"